import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function Breadcrumb(props) {
  const classes = useStyles();
  const breadcrumbColor = 'var(--hrms-primary-blue-end, #036dda)';

  return (
    <div className={`${classes.root} common-breadcrumb`.trim()}>
      <Breadcrumbs
        separator={
          <NavigateNextIcon
            fontSize="small"
            className="common-breadcrumb-separator"
            style={{ color: breadcrumbColor }}
          />
        }
        aria-label="breadcrumb"
      >
        <Link
          className="common-breadcrumb-link"
          color="inherit"
          style={{ color: breadcrumbColor, fontWeight: 600, cursor: 'pointer' }}
          onClick={(e) => {
            e.preventDefault();
            if (window.location.pathname !== '/dashboard') props.history.push('/dashboard');
          }}
        >
          CSPI-EMS
        </Link>
        <Link
          className="common-breadcrumb-link"
          color="inherit"
          style={{ color: breadcrumbColor, fontWeight: 600, cursor: 'pointer' }}
          onClick={(e) => {
            e.preventDefault();
            if (props.primaryPageLink && window.location.pathname !== props.primaryPageLink) {
              props.history.push(props.primaryPageLink);
            }
          }}
        >
          {props.primaryPageName}
        </Link>
        {props.isSecondaryPage && (props.isTertiaryPage || props.tertiaryPageName || props.ternaryPageName) && (
          <Link
            className="common-breadcrumb-link"
            color="inherit"
            style={{ color: breadcrumbColor, fontWeight: 600, cursor: 'pointer' }}
            onClick={(e) => {
              e.preventDefault();
              if (props.secondaryPageLink && window.location.pathname !== props.secondaryPageLink) {
                props.history.push(props.secondaryPageLink);
              }
            }}
          >
            {props.secondaryPageName}
          </Link>
        )}
        {props.isSecondaryPage && (props.isTertiaryPage || props.tertiaryPageName || props.ternaryPageName) ? (
          <Typography
            color="textPrimary"
            className="common-breadcrumb-current"
            style={{ color: breadcrumbColor, fontWeight: 600 }}
          >
            {props.tertiaryPageName || props.ternaryPageName}
          </Typography>
        ) : props.isSecondaryPage ? (
          <Typography
            color="textPrimary"
            className="common-breadcrumb-current"
            style={{ color: breadcrumbColor, fontWeight: 600 }}
          >
            {props.secondaryPageName}
          </Typography>
        ) : null}
      </Breadcrumbs>
    </div>
  );
}
